/* istanbul ignore file */
export var BREAKPOINTS = {
    xs: 0,
    sm: 375,
    sMd: 540,
    md: 768,
    lg: 960,
    xl: 1170,
    xxl: 1440,
};
//# sourceMappingURL=constants.js.map